import { useState, useEffect } from "react";

import { Icons } from "../../../data/Assets";

import MainLayout from "../../layouts/Main";
import { SVGIcon } from "../../wrappers/SVGIcon";
import StudentListTable from "../../sub_components/tables/StudentList";
// import TablePagination from "../../sub_components/tables/TablePagination";
// import ActionDropDown from "../../sub_components/ActionDropDown";
// import ActionButtons from "../../sub_components/student/ActionButtons";
// import StudentActivity from "../../sub_components/student/Activity";

import { useGetInstanceStudents } from "../../../hooks/students";

import { EtyStudent } from "../../../interfaces/entities";

const StudentsPage = () => {
  const [selectedStudents, setSelectedStudents] = useState<number[]>([]);
  const [students, setStudents] = useState<EtyStudent[]>([]);
  const { data: studentTableFields, isLoading } = useGetInstanceStudents();
  // const { mutate: studentDeleteData } = useDeleteStudent();

  useEffect(() => {
    if (studentTableFields?.length) {
      setStudents([...studentTableFields]);
    };
  }, [studentTableFields]);

  const handleStudentSelect = (studentId: number) => {
    setSelectedStudents((prevSelected) => {
      if (prevSelected.includes(studentId)) {
        return prevSelected.filter((id) => id !== studentId);
      } else {
        return [...prevSelected, studentId];
      }
    });
  };

  // const handleSelectAll = () => {
  //   setSelectedStudents(Array.from({ length: students.length }, (_, i) => i));
  // };

  // const handleDeselectAll = () => {
  //   setSelectedStudents([]);
  // };

  // const handleDeleteSelectedStudents = () => {
  //   selectedStudents.forEach((studentId) => {
  //     studentDeleteData({
  //       payload: { id: studentId },
  //       setIsProcessing: () => { },
  //       successCallback: () => {
  //         refreshStudentsList()
  //       },
  //     });
  //   });
  // };

  return (
    <MainLayout>
      <div className="immersion__page_view">
        <h2 className="immersion__color__dark mb_20">Students</h2>

        <div className="immersion__lists__top_section mb_30">
          <div className="display_flex display_flex_end mr_10">
            <button
              // onClick={() => navigate("/students/create")}
              className="mr_10 immersion__btn immersion__btn__primary immersion__btn__primary__disabled"
            >
              <SVGIcon src={Icons.Plus} />
              <span>Add&nbsp;Student</span>
            </button>

            <button className="immersion__btn immersion__btn__outline__primary immersion__btn__outline__primary__disabled">
              <SVGIcon src={Icons.Download4} />
              <span>Import&nbsp;Excel</span>
            </button>
          </div>

          {/* <div className="display_flex immersion__list__action__section mt_20 mb_20">
            <div className="immersion__list__action_section_items display_flex">
              <ActionDropDown
                onSelectAll={handleSelectAll}
                onDeselectAll={handleDeselectAll}
              />
              <ActionButtons onDelete={handleDeleteSelectedStudents} />
            </div>
            <TablePagination start={1} end={students.length} total={158} />
          </div> */}
        </div>

        {/* <div className="immersion__split_views"> */}
        <div className="immersion__split_list_view">
          <StudentListTable
            students={students}
            selectedStudents={selectedStudents}
            onStudentSelect={handleStudentSelect}
            isLoading={isLoading}
          />
        </div>

        {/* <div className="immersion__split_notifications_view">
            <p className="immersion__split_notifications_view__title mb_20">
              Recent Student Activity
            </p>
            <div className="immersion__split_notifications_view__list pl_20 pr_20">
              <StudentActivity />
            </div>
          </div> */}
      </div>
      {/* </div> */}
    </MainLayout>
  );
};

export default StudentsPage;
